var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMouse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.738,
    height: 63.252,
    viewBox: "0 0 42.738 63.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21010",
    "data-name": "Group 21010",
    transform: "translate(19143 14257.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7665",
    "data-name": "Path 7665",
    d: "M26.738,11.117H16a16,16,0,0,0-16,16V58.369a16,16,0,0,0,16,16H26.738a16,16,0,0,0,16-16V27.117a16,16,0,0,0-16-16M3.419,36.76V28.212A13.676,13.676,0,0,1,17.095,14.536V36.76ZM28.277,58.843V55.8H23.2v5.075h3.046l-4.739,4.4-4.738-4.4h3.046V55.8H14.739v3.045l-4.4-4.738,4.4-4.738v3.046h5.077V47.334H16.77l4.738-4.4,4.739,4.4H23.2v5.078h5.076V49.366l4.4,4.738Z",
    transform: "translate(-19143 -14269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouse3);
export default __webpack_public_path__ + "static/media/icon_mouse3.84d2933c81c086d57597c2c08eb9d65d.svg";
export { ForwardRef as ReactComponent };